import { useTranslation } from "react-i18next";

const paymentGatewayOptionsOperationOnline = (list) => {
  const { t } = useTranslation();
  const options = [
    {
      key: "alipay",
      title: t("options.gatewayOperation.online.alipay"),
      value: "ALIPAY",
    },
    {
      key: "amex_bbmsl",
      title: t("options.gatewayOperation.online.amex_bbmsl"),
      value: "AMEX_BBMSL",
    },
    {
      key: "fubon",
      title: t("options.gatewayOperation.online.fubon"),
      value: "FUBON",
    },
    {
      key: "nuvei",
      title: t("options.gatewayOperation.online.nuvei"),
      value: "NUVEI",
    },
    {
      key: "wechat_pay",
      title: t("options.gatewayOperation.online.wechat_pay"),
      value: "WECHAT_PAY",
    },
    {
      key: "worldpay",
      title: t("options.gatewayOperation.online.worldpay"),
      value: "WORLDPAY",
    }
  ].filter(
    (option) =>
      !(process.env.REACT_APP_ENV === "prod" && option.key === "mock"),
  );

  if (typeof list === "string" && list.toLowerCase() === "all") {
    return options;
  }
  if (Array.isArray(list)) {
    const newOptions = [];
    for (const item of list) {
      const newOption = options.find(
        (option) => item === option.value || item === option.key.toLowerCase(),
      );
      newOptions.push(newOption);
    }
    return newOptions;
  }
  return [];
};

export default paymentGatewayOptionsOperationOnline;
